import {getSessionFromSlotOrSession} from "./getSessionFromSlotOrSession";
import {FieldCompInputType} from "@shared/components/FieldsBuilder/fieldCompCustomProps/FieldCompInputType";
import {NOEEndpointExtended} from "@shared/inputs/NOEObjectSelectInput";
import {getAllCustomFieldValuesForEndpoint} from "./getAllCustomFieldValuesForEndpoint";

/**
 * @typedef {object} CustomFieldFilter
 * @property {string} key - Field key
 * @property {string} type - Field input type
 * @property {string} endpoint - Endpoint name
 * @property {Array<string>} filterValues - Array of filter values
 */

/**
 * Tells if a session is selected of not by a custom field
 * @param {CustomFieldFilter} filter - Custom field filter
 * @param {object} session - Session object
 * @param {Array} [registrations] - Optional registrations array
 * @returns {boolean} True if session matches the custom field filter
 */
const sessionIsSelectedByCustomField = ({key, endpoint, filterValues}, session, registrations) => {
  const allCustomFieldValuesForObject = getAllCustomFieldValuesForEndpoint(
    key,
    endpoint,
    session,
    registrations
  );

  // We check if any of the custom fields values gathered is matching the filterValues filter
  return !!filterValues.find((value) => allCustomFieldValuesForObject?.includes(value));
};

/**
 * Filter sessions/slots by custom field values
 * @param {Array} slotsOrSessions - Array of slots or sessions
 * @param {Array<CustomFieldFilter>} customFieldsFilters - Array of custom field filters
 * @param {Array} [registrations] - Optional registrations array
 * @returns {Array} Filtered array of slots/sessions matching all custom field filters
 */
export const filterSessionsByCustomFields = (
  slotsOrSessions,
  customFieldsFilters,
  registrations
) => {
  // Only take the fields which are filtering something. If a filter doesn't have any value, it doesn't filter anything.
  const allFilteredCustomFields = customFieldsFilters.filter(
    ({filterValues}) => filterValues?.length > 0
  );

  // For each slot/session, filter them...
  return slotsOrSessions?.filter((item) => {
    // Get the session
    const session = getSessionFromSlotOrSession(item);
    // And check if it matches all the custom fields filters
    return allFilteredCustomFields.every((customField) =>
      sessionIsSelectedByCustomField(customField, session, registrations)
    );
  });
};
